// @flow
// See: https://redux.js.org/usage/code-splitting#using-a-reducer-manager
import { combineReducers } from 'redux';
export type Reducer = (state: any, action: any) => any;

type ReducerConfig = {
    key: string,
    reducer: Reducer
};

class Reducers {
    _reducers: { [key: string]: Reducer } = {};
    _keysToRemove: Array<string> = [];

    constructor(initialReducers: { [key: string]: Reducer }) {
        this._reducers = initialReducers;
        this._combinedReducer = combineReducers(this._reducers);
    }

    // The root reducer function exposed by this object
    // This will be passed to the store
    reduce(state, action) {
        // if any reducers have been removed, clean up their state first
        if (this._keysToRemove.length > 0) {
            const modifiedState = { ...state };
            for (const key of this._keysToRemove) {
                delete modifiedState[key];
            }
            this._keysToRemove = [];
            return this._combinedReducer(modifiedState, action);
        }

        return this._combinedReducer(state, action);
    }

    add(itemOrItems: ReducerConfig | Array<ReducerConfig>) {
        const items = Array.isArray(itemOrItems) ? itemOrItems : [itemOrItems];
        items.forEach(({ key, reducer }) => {
            // already present
            if (this._reducers[key]) {
                return;
            }
            this._reducers[key] = reducer;
        });

        this._combinedReducer = combineReducers(this._reducers);
    }

    remove(keys: string | Array<string>) {
        const keysToRemove = Array.isArray(keys) ? keys : [keys];
        keysToRemove.forEach(key => {
            if (!this._reducers[key]) {
                return;
            }
            delete this._reducers[key];
            this._keysToRemove.push(key);
        });
        this._combinedReducer = combineReducers(this._reducers);
    }
}

export default Reducers;
